import { PERIOD_CHANGE_LOCK_PERIOD } from "./periodConstants";

/**
 * Whether the user can change billing period.
 * Allowed when more than one period is available and current sub is not yearly.
 *
 * @param {number[]} allowedPeriods
 * @param {{ periods?: number }|null|undefined} paymentDetails
 * @returns {boolean}
 */
const getAllowPeriodChange = (allowedPeriods, paymentDetails) => {
  return Array.isArray(allowedPeriods) && allowedPeriods.length > 1
    ? paymentDetails?.periods !== PERIOD_CHANGE_LOCK_PERIOD
    : false;
};

export default getAllowPeriodChange;
